import { ApiUrls } from '../../../base/services'
import { DateTimeService } from '../../../base/services/DateTimeService'
import { EncryptionService } from '../../../base/services/EncryptionService'
import { Consumer, Dictionary, FileAttachment, Group, MessageChannel } from '../../../base/store/state.interface'

export default {
  computed: {
    messageChannel(): Dictionary<MessageChannel> {
      return this.$store.state.message_channel.items
    },
    groups(): Group {
      return this.$store.state.cluster.group
    },
    consumers(): Consumer {
      return this.$store.state.cluster.consumer
    },
    canAccessAuthorField() {
      const authorFieldAccess = this.$store.state.user.access[this.type + '_fields'].author
      const item = this.item
      return item.author_id !== 0 && (authorFieldAccess === 2 || (authorFieldAccess === 1 && item.editable)) && this.consumers[item.author_id]
    }
  },
  methods: {
    formatUnixTimestamp(ts: number, format = 'dd, DD.MM.YYYY, HH:mm', locale = 'de') {
      return DateTimeService.formatUnixTimestamp(ts, format)
    },
    now(): number {
      return Math.floor(Date.now() / 1000)
    },
    viewAttachment(attachment: FileAttachment) {
      if (attachment.deleted) {
        return
      }

      const filesAccessRights = this.$store.state.user.access.news_fields.files

      try {
        if (filesAccessRights !== 2 && (filesAccessRights !== 1 || !this.item.editable)) {
          return
        }

        if (attachment.encrypted) {
          EncryptionService
            .downloadEncryptedFile(attachment.file_reference_id, this.item.cluster_id, attachment.encryption_iv, attachment.title, attachment.mime_type)
            .catch(() => alert('Laden der Datei ' + attachment.title + ' nicht möglich'))
        } else {
          window.open(location.protocol + '//' + location.host + '/' + ApiUrls.file.open + '/' + attachment.file_reference_id, '_blank')
        }
      } catch (e) {
        console.error(e)
      }
    }
  }
}
